export default "__VITE_ASSET__DHK90z8w__"